export default __webpack_public_path__ + "img/confused-pup.svg";